// extracted by mini-css-extract-plugin
export default {"container":"pincode_container__1-0eA"};